import { ReactNode, useContext, useMemo } from 'react';

import { TrackingContext } from '../../contexts';
import { ElementId, TrackingData } from '../../types';
import { parseElementId } from '../../utils';

export const TrackingScope = ({
  elementId,
  data,
  children,
}: {
  elementId: ElementId;
  data?: TrackingData;
  children: ReactNode;
}) => {
  const { role, name } = parseElementId(elementId);
  const parent = useContext(TrackingContext);

  const value = useMemo(
    () => ({
      path: [...parent.path, { role, name }],
      data: data ? { ...parent.data, ...data } : parent.data,
    }),
    [parent, role, name, data],
  );

  return (
    <TrackingContext.Provider value={value}>
      {children}
    </TrackingContext.Provider>
  );
};
